import { useTheme } from '@emotion/react'
import { Chip } from '@mui/material'
import { RosterSourceStatus } from '__generated__/graphql'
import startCase from 'lodash.startcase'

interface SourceStatusPillProps {
    status?: RosterSourceStatus
}

/**
 * defaults to lodash startCase for most labels but handles special cases like slashes etc here
 * @param status RosterSourceStatus enum (backend generated)
 * @returns formatted string for the status label
 */
export const getSourceStatusLabel = (status: RosterSourceStatus) => {
    switch (status) {
        case RosterSourceStatus.CarveOutNonCpi:
            return 'Carve Out/Non-CPI'
        default:
            return startCase(status)
    }
}

export function SourceStatusPill({
    status = RosterSourceStatus.NoStatus,
}: SourceStatusPillProps) {
    const theme = useTheme()
    const formattedStatus = getSourceStatusLabel(status)
    let backgroundColor = theme.palette.status.grey
    let color = theme.palette.greyscale.white

    switch (status) {
        case RosterSourceStatus.OtherRecruiter:
            backgroundColor = theme.palette.status.orange
            break
        case RosterSourceStatus.CarveOutNonCpi:
            backgroundColor = theme.palette.status.pink
            break
        case RosterSourceStatus.Cpi:
            backgroundColor = theme.palette.status.blue
            break
        case RosterSourceStatus.ClientReferral:
            backgroundColor = theme.palette.status.purple
            break
        case RosterSourceStatus.NoStatus:
        default:
            break
    }

    return (
        <Chip
            label={formattedStatus}
            size="small"
            sx={{ backgroundColor, color }}
            title={formattedStatus}
        />
    )
}
